import styled from "@mui/material/styles/styled";

import Chip from "@rui/Chip";
import { Column } from "@rui/Stack";

export const CategoryContainer = styled(Column)(({ theme }) => ({
  maxWidth: "650px",
  "&:last-of-type": {
    paddingBottom: theme.spacing(2),
  },
}));

export const SettingRow = styled(Column)(({ theme }) => ({
  "&:not(:last-of-type)": {
    paddingBottom: theme.spacing(1),
  },
  "& .MuiSwitch-root": {
    margin: theme.spacing(0, 1),
  },
}));

export const MemberCountChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.transparent.black[4],
  color: theme.palette.shades.neutral[500],
  transition: "all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  "&:hover": {
    cursor: "pointer",
    color: theme.palette.shades.primary[500],
    backgroundColor: theme.palette.shades.ghost[500],
    "& .MuiSvgIcon-root": {
      color: theme.palette.shades.secondary[300],
    },
  },
}));
